/**
 * Authenticate the WS connection
 *
 * @param connection_uid
 * @param wallet_addr
 * @param device_type
 * @param signerFn
 * @param cb
 */
export function authenticateConnection(connection_uid, wallet_addr, device_type, signerFn = (msg) => {return null}, cb) {
    if (wallet_addr === '') { //Guest mode
        console.log("Joining as guest")
        cb(device_type)
        return
    }

    if (!signerFn) {
        throw new Error("Missing connection signer")
    }

    getNonce(wallet_addr, (nonce) => {
        const msg = `I am signing my game-authentication nonce: ${wallet_addr}:${nonce}`

        signerFn(msg).then((r) =>  {
            const payload = {
                game_uid: connection_uid,
                device_type: device_type,
                public_address: wallet_addr,
                signed: r
            }

            login(payload, cb)
        }).catch(e => {
            console.error("Auth failed", e)
            cb()
        })
    })
}

export function login(payload, cb) {
    console.log("Authenticating: ", payload)

    var xhr = new XMLHttpRequest();
    xhr.open("POST", 'https://app.alphabatem.com/auth', true);
    // xhr.open("POST", 'http://localhost:9093/auth', true);

//Send the proper header information along with the request
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () { // Call a function when the state changes.
        if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
            console.log("authenticated");
            cb(payload.device_type)
        }
    }
    xhr.send(JSON.stringify(payload));
}

export function getNonce(wallet_addr, cb) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", 'https://app.alphabatem.com/auth/nonce/' + wallet_addr, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () { // Call a function when the state changes.
        if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
            console.log("authenticated");
            cb(JSON.parse(xhr.response).nonce)
        }
    }
    xhr.send();
}